import SymbologyLibrary from "../components/symbology/SymbologyLibrary";

export default function Symbology() {
  return (
    <div className="space-y-4" data-testid="symbology-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-[var(--c-text)] font-heading">
          Symbology Library
        </h1>
        <p className="text-sm text-[var(--c-muted)] mt-1 max-w-3xl">
          The exact graphical symbols the drawing generators draw with — IEC 60617 / IEEE 315
          schematic devices and true-shape mechanical outlines (IEC 60076, ASME VIII, ISO 14617,
          TEMA). Pick symbols to build a legend sheet, or pull any symbol as SVG / DXF.
        </p>
      </div>
      <div className="h-[calc(100vh-230px)] min-h-[520px] bg-[var(--c-bg)] border border-[var(--c-border)] rounded-sm overflow-hidden">
        <SymbologyLibrary />
      </div>
    </div>
  );
}
